exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*!\n * Developed for G.J. Gardner Homes by Softeq Development Corporation\n * http://www.softeq.com\n */:host{display:block;padding:25px 20px}.m-scheme-list{display:flex;flex-direction:column}.m-scheme-option+.m-scheme-option{margin-top:50px}.m-scheme{display:flex;flex-direction:row}.m-color{position:relative}.m-color+.m-color{margin-left:30px}.m-color-box{width:60px;height:60px;border:1px solid #fff}.m-color-title{position:absolute;left:50%;transform:translateX(-50%)}.mat-radio-button{margin-right:0}", ""]);

// exports
